<template>
    <div class="final-results">
      <div class="results-header">
        <h2 class="results-title h3">Your Top {{ resultCount }} Values</h2>
        <pdfGenerator
            v-if="assessmentComplete"
            :allValues
            :topValues />
      </div>

      <div class="results">
        <div class="result" v-for="(score, value, index) in topValues" :key="value">
          <h3 class="value h4">{{ index + 1 }}) {{ value }} <span>(votes: {{score}})</span></h3>
          <p class="definition">{{ getValueDefinition(value) }}</p>
        </div>
      </div>

    </div>
</template>


<script>
import pdfGenerator from "./pdfGenerator.vue";

export default {
  components: {pdfGenerator},

  props:      {
    allValues: {
      type: Array
    },
    remainingValues: {
      type: Array
    },
    rankedValues: {
      type: Object
    },
    resultCount: {
      type: Number
    },
    assessmentComplete: {
      type: Boolean
    },
  },

  data() {
    return {

    };
  },
  mounted() {
    // console.log('Results component mounted')
  },
  computed: {
    topValues() {
      const results = {};
      this.remainingValues.forEach((item) => (results[item.name] = 0));
      for (const pair in this.rankedValues) {
        results[this.rankedValues[pair]]++;
      }

      // Order the values according to their rankedValues
      let orderedResults = Object.entries(results)
          .sort(([, a], [, b]) => b - a)
          .reduce((r, [k, v]) => ({...r, [k]: v}), {});

      console.log(orderedResults);

      // Return the specified result count
      return Object.fromEntries(
          Object.entries(orderedResults).slice(0, this.resultCount)
      );

    },
  },
  methods:  {
    getValueDefinition(value) {
      for (let i = 0; i < this.allValues.length; i++) {
        if (this.allValues[i].name === value) {
          return this.allValues[i].definition_full;
        }
      }
    }
  }
}

</script>
